import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

export interface CardLink {
  icon: string;
  url: string;
}

@Component({
  selector: 'app-card-view-simple-card',
  templateUrl: './card-view-simple-card.component.html',
  styleUrls: ['./card-view-simple-card.component.css']
})
export class CardViewSimpleCardComponent implements OnInit {

  @Input() title: string;
  @Input() links: CardLink[];
  @Input() actionButtons: [];
  @Input() defaultLink: string;
  @Input() showDelete: boolean = true;
  @Input() showEdit: boolean = true;

  @Output() click = new EventEmitter<boolean>();
  @Output() onDelete = new EventEmitter<Event>();
  @Output() onUpdate = new EventEmitter<Event>();
  actionTriggers: EventEmitter<{}>[] = [
    new EventEmitter<{}>(),
    new EventEmitter<{}>(),
    new EventEmitter<{}>(),
    new EventEmitter<{}>()
  ]

  @Output() action_0 = this.actionTriggers[0];
  @Output() action_1 = this.actionTriggers[1];
  @Output() action_2 = this.actionTriggers[2];
  @Output() action_3 = this.actionTriggers[3];


  constructor(private router: Router, public auth: AuthService) { }

  ngOnInit() {
  }

  goto(event, url) {
    console.log("url", url)
    event.stopPropagation();
    this.click.emit(event);
    if (typeof url === 'string') {
      this.router.navigateByUrl(url);
    } else if (typeof url === 'function') {
      url();
    }
  }

  actionTriggeredHandler($event: Event, id, url: string, relativeUrl: string) {
    $event.stopPropagation();
    if (id < this.actionTriggers.length) {
      this.actionTriggers[id].emit($event);
      if (relativeUrl) {
        if (relativeUrl.toLowerCase().includes('https')){
          let siteId = url.split('/')[3];
          let systemId =  url.split('/')[5];
          window.open(relativeUrl.replace('undefined',siteId)+systemId, "_blank");
        }
        else
          this.router.navigateByUrl(url + '/' + relativeUrl);
      }
    }
  }

  deleteHandler($event: Event) {
    $event.stopPropagation();
    this.onDelete.emit($event);
  }

  updateHandler($event: Event) {
    $event.stopPropagation();
    this.onUpdate.emit($event);
  }
}
